module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/mainpic_5d2e5ad2bd78f7608ccee45188252b13.png";